import React, { useState } from 'react';
import Link from 'next/link';
import classnames from 'classnames';

import { resolveLink } from '../../../utils/resolveLink';
import useResponsive from '../../../utils/hooks/useResponsive';
import LeadFormModal from '../../modal/LeadFormModal/LeadFormModal';
import { GTM_ACTION, GTM_CLASS, GTM_CLASS_PREFIX } from '../../../lib/constant';
import { PopupLeadForm } from '../../../lib/types';

import styles from './ArticleBanner.module.scss';
import { getNameFromPath } from '../../../lib/stringManipulate';

interface ArticleBannerProps {
  type: string;
  title?: string;
  categorySlug?: string;
  data: Record<string, any>;
}

const ArticleBanner = (props: ArticleBannerProps) => {
  const { title, data, categorySlug, type } = props;

  const { isDesktop } = useResponsive();
  const [isShowPopup, setIsShowPopup] = useState(false);
  const [gtmAction, setGtmAction] = useState(GTM_ACTION.IN_ARTICLE_BANNER);

  const handlePopup = (showPopup: boolean, popupData?: PopupLeadForm) => {
    handleGtmAction(popupData);
    setIsShowPopup(showPopup);
  };

  const setImage = (imgData) => {
    if (isDesktop) {
      return imgData.imageDesktop ? imgData.imageDesktop : imgData.imageDesktopUrl;
    } else {
      return imgData.imageMobile ? imgData.imageMobile : imgData.imageMobileUrl;
    }
  };

  const handleGtmAction = (popupData) => {
    let imgPath = null;
    if (popupData && popupData.bannerMobileUrl && popupData.bannerDesktopUrl) {
      imgPath = isDesktop ? popupData.bannerDesktopUrl : popupData.bannerMobileUrl;
    }

    const imgName = imgPath ? getNameFromPath(imgPath) : '';
    if (!imgName) {
      setGtmAction(GTM_ACTION.IN_ARTICLE_BANNER);
    }

    setGtmAction(GTM_ACTION.IN_ARTICLE_BANNER + '-' + imgName);
  };

  if (type === 'POPUP') {
    const inArticleBannerPopup = {
      bannerMobileUrl: data.imageMobileUrl,
      bannerDesktopUrl: data.imageDesktopUrl,
      title: data.leadFormTitle,
      category: data.leadForm,
      category_value: data.leadForm,
      useTimer: false,
      isOpen: true,
      gtmAction: gtmAction,
    };
    return (
      <>
        {isShowPopup && (
          <LeadFormModal
            popupData={inArticleBannerPopup}
            closePopup={() => {
              setIsShowPopup(false);
            }}
          />
        )}
        <div
          className={styles.articleBanner}
          onClick={() => handlePopup(true, inArticleBannerPopup)}
        >
          <img
            src={setImage(data)}
            alt={data.title || title}
            loading="lazy"
            width="322px" height="280px"
            className={classnames(
              GTM_CLASS.OPEN_LEADFORM_IN_ARTICLE_BANNER,
              `${GTM_CLASS_PREFIX}${categorySlug}`,
            )}
          />
        </div>
      </>
    );
  } else {
    return (
      <div className={styles.articleBanner}>
        <Link href={data.linkUrl ? resolveLink(data.linkUrl) : '#'}>
          <a title={data.title || title} className={GTM_CLASS.REDIRECTION_IN_ARTICLE_CTA_BANNER}>
            <img src={setImage(data)} alt={data.title || title} loading="lazy" width="322px" height="280px" />
          </a>
        </Link>
      </div>
    );
  }
};

export default ArticleBanner;
